import { request } from "_utilities/request";
import {
  setCompanyData,
  setComplementaryData,
  setCountries,
  setCreateAccount,
  setCreateDemo,
  setInitialData,
  setMediaList,
  setProductTypes,
  setSalesChannels,
  setSalesChannelsList,
  setUserData,
  startCompanyData,
  startComplementaryData,
  startCountries,
  startCreateAccount,
  startCreateDemo,
  startInitialData,
  startMediaList,
  startProductTypes,
  startSalesChannels,
  startSalesChannelsList,
  startUserData
} from "./slices";
import { setTld, startTld } from "../account/slices";

/**
 * 
 * @param { Object } params 
 * @param { Object } extras 
 * @returns 
 */
export const fetchCountries = (params, extras = {}) => 
  async (dispatch) => {
    try {
      dispatch(startCountries());
      let res = await request({
        endpoint: "/getter/collection/country-list",
        type: "get",
        params,
        ...extras
      })
      .catch((e) => console.log("Error:", e));
      let { data } = await res;
      dispatch(setCountries({ data })); 
    } catch (e) {}
  };

export const fetchMediaList = (params, extras = {}) => 
  async (dispatch) => {
    dispatch(startMediaList());
    let res = await request({
      endpoint: "/getter/collection/media-list",
      type: "get",
      params,
      ...extras
    });
    let { data, error } = res;
    dispatch(setMediaList({ data, error }));
  };

/**
 * 
 * @param { Object } params 
 * @param { Object } extras 
 * @returns 
 */
export const fetchProductTypes = (params, extras = {}) =>
  async (dispatch) => {
    dispatch(startProductTypes());
    let res = await request({
      endpoint: "/getter/collection/producttype-list",
      type: "get",
      params,
      ...extras
    })
    .catch((e) => console.log("Error:", e));
    let { data } = await res;
    dispatch(setProductTypes({ data }));
  };

export const fetchSalesChannels = (params, extras = {}) =>
  async (dispatch) => {
    dispatch(startSalesChannelsList());
    let res = await request({
      endpoint: "/getter/collection/channel-list",
      type: "get",
      params,
      ...extras
    })
    .catch((e) => console.log("Error:", e));
    let { data, error } = res;
    dispatch(setSalesChannelsList({ data }));
    return { data, error };
  };


/**
 * 
 * @param {*} data 
 * @param {*} extras 
 * @returns 
 * 
 * body: {
 *  c: Array [
 *    Object: {
 *      step: 0,
 *      data: {
 *        firstName: String,
 *        lastName: String,
 *        metBy: String
 *      }
 *    }
 *  ]
 * }
 */
export const userData = (_id, post, extras = {}) =>
  async (dispatch) => {
    dispatch(startUserData());
    let resp = await request({
      endpoint: "/enrollment/process/step",
      type: "put",
      params: { _id },
      data: {
        c: [{
          data: post,
          step: 0
        }]
      },
      ...extras
    });
    let { data, error } = resp;
    dispatch(setUserData({ data }));
    return { data, error };
  };

/**
 * 
 * @param { Object } post 
 * @param { Object } extras 
 * @returns 
 * 
 * body: {
 *  c: Array [
 *    Object: {
 *      step: 1,
 *      data: {
 *        enterprise: String,
 *        producttypeKey: String,
 *        countryKey: String
 *      }
 *    }
 *  ]
 * }
 */

export const companyData = (_id, put, extras = {}) =>
  async (dispatch) => {
    dispatch(startCompanyData());
    let resp = await request({
      endpoint: "/enrollment/process/step",
      type: "put",
      params: { _id },
      data: {
        c: [{
          step: 1,
          data: put
        }]
      },
      ...extras
    });
    let { data, error } = resp;
    dispatch(setCompanyData({ data }));
    return { data, error };
  };

/**
 * 
 * @param { Object } put 
 * @param { Object } extras 
 * @returns 
 * 
 * body: {
 *  c: Array [
 *    Object: {
 *      step: 2,
 *      data: {
 *        estimatedProductRange: String
 *      }
 *    }
 *  ]
 * }
 */
export const initialData = (_id, put, extras = {}) => 
  async (dispatch) => {
    dispatch(startInitialData());
    let res = await request({
      endpoint: "/enrollment/process/step",
      type: "put",
      params: { _id },
      data: {
        c: [{
          step: 2,
          data: put
        }]
      },
      ...extras
    });
    let { data, error } = res;
    dispatch(setInitialData({ data }));
    return { data, error };
  };

/**
 * 
 * @param { Object } put 
 * @param { Object } extras 
 * 
 * body: {
 *  c: Array [
 *    Object: {
 *      step: 3,
 *      data: {
 *        channelsKey: String
 *      }
 *    }
 *  ]
 * }
 */
export const salesChannels = (_id, put, extras = {}) => 
  async (dispatch) => {
    dispatch(startSalesChannels());
    let res = await request({
      endpoint: "/enrollment/process/step",
      type: "put",
      params: { _id },
      data: {
        c: [{
          step: 3,
          data: put
        }]
      },
      ...extras
    });
    let { data, error } = res;
    dispatch(setSalesChannels({ data }));
    return { data, error };
  };

/**
 * 
 * @param { Object } put 
 * @param { Object } extras 
 * @returns 
 * 
 * body: {
 *  c: Array [
 *    Object: {
 *      step: 4,
 *      data: {
 *        pim: String,
 *        dam: String,
 *        publisher: String
 *      }
 *    }
 *  ]
 * }
 */
export const complementaryData = (_id, put, extras = {}) =>
  async (dispatch) => {
    dispatch(startComplementaryData());
    let res = await request({
      endpoint: "/enrollment/process/step",
      type: "put",
      params: { _id },
      data: {
        c: [{
          step: 4,
          data: put
        }]
      },
      ...extras
    });
    let { data, error } = res;
    dispatch(setComplementaryData({ data, error }));
    return { data, error };
  };

/**
 * 
 * @param {Object} params 
 * @param {Object} extras 
 * @returns 
 */
export const createAccount = (params, extras = {}) => 
  async (dispatch) => {
    dispatch(startCreateAccount());
    let res = await request({
      endpoint: "/onboarding/process/start",
      type: "post",
      params,
      ...extras
    });
    let { data, error } = res;
    dispatch(setCreateAccount({ data, error }));
    return { data, error };
  };


/**
 * 
 * @param {Object} params 
 * @param {Object} extras 
 * @returns 
 */
export const createDemo = (params, extras = {}) => 
  async (dispatch) => {
    dispatch(startCreateDemo());
    let res = await request({
      endpoint: "/account/enable/demo",
      type: "post",
      params,
      ...extras
    });
    let { data, error } = res;
    dispatch(setCreateDemo({ data, error }));
    return res;
  };

/** 
 * 
*/
export const fetchTld = (params, extras = {}) =>
  async (dispatch) => {
    dispatch(startTld());
    let res = await request({
      endpoint: "/getter/collection/domainemail-list",
      type: "get",
      params,
      ...extras
    });
    const { data, error } = res;
    dispatch(setTld({ data, error }));
  };
